// ============================================================
// Practice Mode — sandbox for recruits.
// ============================================================
// When ON:
//   • Lead Hunter runs REAL AI research (this is the whole point of training)
//   • BUT the "Approve & Inject to GVO Auto-Net" button skips the real
//     backend call and pops a celebratory training success modal instead.
//   • Hunts are still persisted to Mongo, tagged `practice: true`, so real
//     Auto-Net dashboards can filter them out.
// Persisted in sessionStorage so it survives page navigation but resets
// on browser close (safer than localStorage — no risk of a leader leaving
// the app in practice mode forever).

const KEY = "wa_practice_mode_v1";
const listeners = new Set();

export function getPracticeMode() {
  try {
    return typeof window !== "undefined" && sessionStorage.getItem(KEY) === "1";
  } catch (_e) {
    return false;
  }
}

export function setPracticeMode(on) {
  try {
    sessionStorage.setItem(KEY, on ? "1" : "0");
  } catch (_e) {
    /* private mode — no-op */
  }
  const val = !!on;
  listeners.forEach((fn) => {
    try { fn(val); } catch (_) { /* ignore */ }
  });
}

export function subscribePractice(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}
